<template>
  <div>
    <date-picker
      @input="$emit('input', $event)"
      @blur="$emit('blur', $event)"
      :value="value"
      :placeholder="placeholder"
      :lang="lang"
      :append-to-body="appendToBody"
      :format="format"
      :value-type="valueType"
      :disabled-date="disabledDate"
      :disabled="disabled"
      prefix-class="dnpr"
      class="custom-date-picker"
      :class="{'custom-date-picker--error': error && showErrorMsg}"
    />
    <p class="control-box__help-block invalid dirty" v-if="error && showErrorMsg">{{ error }}</p>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/locale/ru'
import 'vue2-datepicker/locale/uk'

export default {
  name: 'CustomDatePicker',
  components: {
    DatePicker
  },
  props: {
    value: String,
    placeholder: String,
    lang: String,
    appendToBody: Boolean,
    format: String,
    valueType: String,
    className: String,
    disabledDate: Function,
    error: [String, Boolean],
    showErrorMsg: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
$namespace: 'dnpr';
$default-color: #333;
$primary-color: #ff2f00;

@import '~vue2-datepicker/scss/index.scss';

.custom-date-picker {
  margin-top: 5px;
  margin-bottom: 10px;
  width: 100%;
}

.custom-date-picker .dnpr-input {
  height: 40px;
  font-size: 16px;
  border: 1px solid #E7E7E7;
  border-radius: 3px;
  box-shadow: none;

  &:focus,
  &:focus:hover {
    border-color: #333;
  }

  &:hover {
    border-color: #E7E7E7;
  }
}

.custom-date-picker--error .dnpr-input {
  border-color: #FF4D42;

  &:hover {
    border-color: #FF4D42;
  }
}

.dnpr-datepicker-popup {
  z-index: 2;
}

</style>
